export const HOST = process.env.REACT_APP_API_URL as string;

export const API_V1_URL = "api/v1";
